import * as React from 'react';

const expandSrc = `${window.postbuildEnv.CDN_URL}/images/icons/expand.svg`;

interface ExpandableCardProps {
  imgSrc: string,
  imgAlt: string,
  isExpanded: boolean,
  onClick: (event: React.SyntheticEvent<HTMLButtonElement | HTMLDivElement>) => void,
  header: string,
  text:string,
  rows: {
    imgAlt: string,
    imgSrc: string,
    name: string,
    onClick: (event: React.SyntheticEvent<HTMLButtonElement>) => void
  }[]
}

export const ExpandableCard = ({ imgSrc, imgAlt, isExpanded, onClick, header, text, rows }: ExpandableCardProps) => {

  function renderExpandedSection() {
    if(!rows) { return }
    return(
      <section className="expanded-section">
        {rows.map((row, i) => {
          const { imgAlt, imgSrc, name, onClick } = row;
          return(
            <section className="row-section" key={`${name}-${i}`}>
              <button className="row-name-button focus-on-light" onClick={onClick}>
                <p className="row-name-label">{name}</p>
              </button>
              <button className="row-button focus-on-light" onClick={onClick} value="row-button">
                <img alt={imgAlt} src={imgSrc} />
              </button>
            </section>
          )
        })}
      </section>
    );
  }

  const img = imgSrc ? <img alt={imgAlt} className="expandable-card-icon" src={imgSrc} /> : null;
  const cardClass = `expandable-quill-card ${isExpanded ? 'open' : ''}`;

  return (
    <div className={cardClass}>
      <button aria-expanded={isExpanded} className="expandable-quill-card-trigger focus-on-light" onClick={onClick} type="button">
        <section className="upper-content-section">
          {img}
          <div className="text">
            <h3>{header}</h3>
            <p>{text}</p>
          </div>
          <img alt="arrow" className="expand-arrow" src={expandSrc} />
        </section>
      </button>
      {isExpanded && renderExpandedSection()}
    </div>
  )
}

export default ExpandableCard;
